import { AxiosResponse } from "axios";
import { ISelectType } from "@4uhub/lib4uhub";

import { domainValueList } from "./domainValue.service";
import { patientCareCharacterList } from "./patientCareCharacter.service";
import { patientEncounterClassificationList } from "./patientEncounterClassification.service";
import { patientEncounterComplaintList } from "./patientEncounterComplaint.service";
import { sectorEmr } from "./sectorEmr.service";
import { getSectorAccommodationTypesList } from "./tasySectorAccommodationType.service";
import { insuranceRegisterList } from "./ticketAutomationReceivedRuleInsurance.service";
import { calendarRegisterList } from "./ticketAutomationReceivedSlotCalendar.service";

// Ids de DomainValue do Tasy usados na regra de check-in
export const DOMAIN_VALUE_PATIENT_ENCOUNTER_TYPE = 12;
export const DOMAIN_VALUE_TISS_ATTENDANCE_TYPE = 1761;
export const DOMAIN_VALUE_PATIENT_ENCOUNTER_ORIGIN = 8;
export const DOMAIN_VALUE_INSURANCE_TYPE = 11;

// Converte o retorno da rota em opções de seleção, mantendo o restante da resposta
const toOptions = <T>(
  request: Promise<AxiosResponse<T[]>>,
  map: (item: T) => ISelectType,
): Promise<AxiosResponse<ISelectType[]>> =>
  request.then((response) => ({ ...response, data: response.data.map(map) }));

export const domainValueOptions = (params?: any) =>
  toOptions(domainValueList(params), (item) => ({
    id: item.identifierValue,
    name: item.domainValueName,
  }));

export const patientEncounterClassificationOptions = (params?: any) =>
  toOptions(patientEncounterClassificationList(params), (item) => ({
    id: String(item.identifier),
    name: item.description ?? "",
  }));

export const patientCareCharacterOptions = (params?: any) =>
  toOptions(patientCareCharacterList(params), (item) => ({
    id: item.identifier ?? "",
    name: item.description ?? "",
  }));

export const sectorOptions = (params?: any) =>
  toOptions(sectorEmr(params), (item) => ({
    id: String(item.identifier),
    name: item.name,
  }));

export const accommodationTypeOptions = (params?: any) =>
  toOptions(getSectorAccommodationTypesList(params), (item) => ({
    id: item.identifier,
    name: item.description,
  }));

export const insuranceOptions = (params?: any) =>
  toOptions(insuranceRegisterList(params), (item) => ({
    id: String(item.identifier),
    name: item.insuranceName,
  }));

export const calendarOptions = (params?: any) =>
  toOptions(calendarRegisterList(params), (item) => ({
    id: String(item.identifier),
    name: `${item.descriptionSite?.trim() || item.calendarName} - ${item.identifier}`,
  }));

// A rota de queixa é paginada: percorre todas as páginas e devolve a lista completa
export const patientEncounterComplaintOptions = async (
  params?: any,
): Promise<AxiosResponse<ISelectType[]>> => {
  const items: ISelectType[] = [];
  let pageNumber = 1;
  let lastResponse: AxiosResponse | undefined;

  while (true) {
    const response = await patientEncounterComplaintList({ ...params, pageNumber });
    lastResponse = response;
    items.push(
      ...response.data.items.map((item) => ({
        id: String(item.identifier),
        name: item.description,
      })),
    );
    if (pageNumber >= response.data.totalPages) break;
    pageNumber++;
  }

  return { ...lastResponse, data: items } as AxiosResponse<ISelectType[]>;
};
